import { useQuery } from '@tanstack/react-query'

import { getFileUploadConfig, getFileMetadata } from '@/services/api/file.service'
import type { FileUploadConfig, FileMetadata } from '@/types/api/file'

/** Global upload policy (max size + allowed types). Cached aggressively — it is static config. */
export function useFileUploadConfig() {
  return useQuery<FileUploadConfig>({
    queryKey: ['file-upload-config'],
    queryFn: getFileUploadConfig,
    staleTime: 30 * 60 * 1000,
  })
}

/**
 * Batch metadata (+ pre-signed download URLs) for the given keys. Pass an empty
 * array to stay idle — useful when the caller already supplies metadata.
 */
export function useFileMetadata(keys: string[]) {
  const sortedKeys = [...keys].sort()
  return useQuery<FileMetadata[]>({
    queryKey: ['file-metadata', sortedKeys],
    queryFn: () => getFileMetadata(sortedKeys),
    enabled: sortedKeys.length > 0,
    staleTime: 5 * 60 * 1000,
  })
}
